export default "__VITE_ASSET__42d90c5d__"